export default __webpack_public_path__ + "static/media/element_spec_39.ab0c11c2.jpg";